import mutations from './mutations/index'
import actions from './actions/index'
import getters from './getters/index'

const state = {
  _finalRank: null,
  _preRank: { // 1晋级榜2买入榜3卖出榜
    1: null,
    2: null,
    3: null
  },
  _winners: null
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
